import { Box } from '@chakra-ui/react'
import { ApexOnlineMenu, menuItems, menuPermissions } from 'apex-online-menu'
import { MenuItem, SearchAccountsResponsePayload } from 'apex-ui-services'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { useAuth } from '../../hooks'
import { RootState } from '../../store'
import { getAppConfigSetting } from '../../utils'

const apiUrl: string = getAppConfigSetting('apiUrl') as string

export interface Props {
  menuItems: MenuItem[]
  menuPermissions: any
  menuItemsRequest: (apiUrl: string) => void
  menuPermissionsRequest: (apiUrl: string) => void
  handleSignout: () => void
  accountInformation?: SearchAccountsResponsePayload | null
}

export const ApexMenuComponent = ({
  menuItems,
  menuPermissions,
  accountInformation,
  menuItemsRequest,
  menuPermissionsRequest,
  handleSignout,
}: Props) => {
  const { showAppContent } = useAuth()

  useEffect(() => {
    if (showAppContent) {
      menuItemsRequest(apiUrl)
      menuPermissionsRequest(apiUrl)
    }
  }, [menuItemsRequest, menuPermissionsRequest, showAppContent])

  const getLegacyUrl = () => {
    const cookie = document.cookie
    const parts = cookie.split(';')
    const apexURL = parts.find(p => p.includes('apexOnlineURL'))
    if (apexURL) {
      return apexURL.split('URL=')[1]
    }
    return null
  }

  return (
    <Box
      fontWeight="medium"
      sx={{
        '.navbar-left': {
          "li:first-of-type[role='presentation']": {
            height: '40px',
          },
        },
        li: {
          a: {
            display: 'inline-flex',
            alignItems: 'center',
            span: {
              display: 'inline-flex',
            },
          },
        },
        '.navbar-right': {
          svg: {
            marginLeft: '4px',
          },
        },
      }}
    >
      <ApexOnlineMenu
        items={menuItems}
        userPermissions={menuPermissions}
        legacyUrl={getLegacyUrl()}
        showLogout={showAppContent}
        logout={handleSignout}
        accountNumber={accountInformation?.accountNumber}
      />
    </Box>
  )
}

const mapDispatchToProps = {
  menuItemsRequest: menuItems.request,
  menuPermissionsRequest: menuPermissions.request,
}

const mapStateToProps = (state: RootState) => {
  return {
    menuItems: menuItems.selectors.menuItemsResults(state),
    menuPermissions: menuPermissions.selectors.menuPermissionsResults(state),
  }
}

export const ApexMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(ApexMenuComponent)
